import React, { memo } from 'react';

import { IconTooltip } from '../IconTooltip';
import { Hint, HintsContainer, StyledTooltipWrapper, StyledWrapper, Title } from './styled';

type Props = {
  title: string;
  hints: {
    dataTestId: string;
    content: JSX.Element;
  }[];
  tooltipIndex?: number | null;
  tooltipText?: string;
};

const TextWithHint = ({ title, hints, tooltipIndex, tooltipText }: Props): JSX.Element => (
  <div>
    <Title data-testid="textWithHint">{title}</Title>
    <HintsContainer>
      {hints.map(({ dataTestId, content }, index: number) => (
        <StyledWrapper key={index}>
          <Hint key={index} data-testid={dataTestId}>
            {content}
          </Hint>
          {index === tooltipIndex && (
            <StyledTooltipWrapper>
              <IconTooltip textTestId={dataTestId} text={''} description={tooltipText} />
            </StyledTooltipWrapper>
          )}
        </StyledWrapper>
      ))}
    </HintsContainer>
  </div>
);

export default memo(TextWithHint);
